export const GLOBAL_ERROR_MESSAGES = {
  en: {
    errors: {
      repeatedErrors: 'Repeated errors detected',
      workspaceErrorTitle: 'Editor needs recovery',
      somethingWentWrong: 'Something went wrong',
      repeatedErrorMessage: 'Repeated errors detected. Try clearing all cache and retry.',
      workspaceError: 'The editor ran into a problem. Refresh the editor to reload the latest safe state, or go back to Explore.',
      appError: 'The application encountered an issue. Please try refreshing the page.',
      recoveryEyebrow: 'Recovery',
      recoverySafetyNote: 'Your saved work is not deleted by this screen. We have recorded the issue automatically.',
      recoveryLogged: 'Recovery ID: {recoveryId}',
      errorCount: 'Error count: {count}',
      refreshEditor: 'Refresh Editor',
      refreshPage: 'Refresh Page',
      retry: 'Retry',
      backToExplore: 'Back to Home',
      clearCache: 'Clear Cache',
      recoveryIdCopied: 'Error ID copied',
      errorDetails: 'Error Details (Dev Mode)',
      errorMessage: 'Error message:',
      stackTrace: 'Stack trace:',
      componentStack: 'Component stack:',
      errorLogsPrinted: 'Error logs printed to console',
      noErrorLogs: 'No error logs available',
      viewErrorLogs: 'View Error Logs',
    },
  },
  zh: {
    errors: {
      repeatedErrors: '检测到重复错误',
      workspaceErrorTitle: '编辑器需要恢复',
      somethingWentWrong: '出错了',
      repeatedErrorMessage: '检测到重复错误，请尝试清除所有缓存后重试。',
      workspaceError: '编辑器遇到问题了。刷新编辑器可重新加载最新安全状态，也可以先返回探索页。',
      appError: '应用程序遇到了问题，请尝试刷新页面。',
      recoveryEyebrow: '恢复',
      recoverySafetyNote: '这个页面不会删除你已保存的作品。系统已经自动记录这次问题。',
      recoveryLogged: '恢复编号：{recoveryId}',
      errorCount: '错误次数：{count}',
      refreshEditor: '刷新编辑器',
      refreshPage: '刷新页面',
      retry: '重试',
      backToExplore: '回到首页',
      clearCache: '清除缓存',
      recoveryIdCopied: '错误 ID 已复制',
      errorDetails: '错误详情（开发模式）',
      errorMessage: '错误信息：',
      stackTrace: '堆栈跟踪：',
      componentStack: '组件堆栈：',
      errorLogsPrinted: '错误日志已输出到控制台',
      noErrorLogs: '暂无错误日志',
      viewErrorLogs: '查看错误日志',
    },
  },
} as const;
